import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BASE_IMG_URL } from '@images/imageUrls';
import { px2rem } from '@utils/px2rem'
import { getAvatarImageSrc } from '@utils/avatarImageSrc';
import { observable, toJS } from 'mobx';

interface H5AvatarListProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    size?: any  // 头像尺寸
    userList: any   // 用户列表
    userCount?: any  // 显示的用户数量，默认3个
}

@inject('app', 'site', 'user')
@observer
class H5AvatarList extends React.Component<H5AvatarListProps> {
    // 处理图片加载错误
    handleImageError: React.ReactEventHandler<HTMLImageElement> = (event) => {
        const imgElement = event.currentTarget;
        const avatarSize = this.props.size || 32;
        imgElement.src = getAvatarImageSrc(`${BASE_IMG_URL}/common/avatar.png`, avatarSize, avatarSize);
        // 防止默认图也加载失败时陷入死循环
        imgElement.onerror = null;
    };
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }

    render() {
        const { userList, size, userCount = 3 } = this.props;
        const avatarSize = size || 32;
        console.log(userList, '用户头像列表')
        // 正确的 style 对象
        const sizeStyle = size ? {
            width: `${px2rem(size)}`,
            height: `${px2rem(size)}`,
            marginRight: `-${px2rem(size/2)}`
        } : {};
        const observableArray = observable(userList);
        const normalArray = toJS(observableArray); // 转换为普通数组
        return <>
            <div className={styles.avatarListBox}>
                {normalArray.slice(0, userCount).map((item: any, index: any) => (
                    <img src={getAvatarImageSrc(item.avatar || item || `${BASE_IMG_URL}/common/avatar.png`, avatarSize, avatarSize)} onError={this.handleImageError} key={index} alt=""style={{ ...sizeStyle, zIndex: index }} className={styles.avatar}/>
                ))}
            </div>
        </>;
        
    }
}

export default H5AvatarList;
